import { GOVGR_FILE_UPLOAD } from "../../conf/styles/GovGrFileInput";

const Input = ({
  name,
  disabled,
  isSubmitting,
  onChange,
  accept,
  uploadedFilename,
}) => {
  return (
    <>
      <div style={{ marginTop: "10px" }}>
        <label htmlFor={name || "filename"}>{uploadedFilename}</label>
        {!disabled && (
          <input
            className={GOVGR_FILE_UPLOAD}
            accept={accept}
            type="file"
            name={name || "filename"}
            disabled={disabled || isSubmitting}
            onChange={onChange}
          />
        )}
      </div>
    </>
  );
};

export default Input;
